/**
 * Marka bilgisi — tek kaynak (K36). Ad/logo değişince yalnız burası değişir.
 * Görünen metinler i18n'de `{brand}` yer tutucusuyla bu adı kullanır.
 */
export const brand = {
  /** Görünen ad. Ortam değişkeni (VITE_APP_NAME) veya varsayılan Halkora. */
  name: (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_APP_NAME) || "Halkora",
  /** Tek renkli logo (SVG maske olarak boyanır, bkz. ui/BrandMark). */
  logoPath: "/brand/logo.svg",
  /** Tarayıcı sekmesi başlığı. */
  title: (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_APP_NAME) || "Halkora",
} as const;

export function getBrandName(): string {
  return brand.name;
}

